import { css } from 'styled-components';
import { RoundedProps, ThemedProps } from '../types';

export const applyRoundedCorners = ({ rounded }: ThemedProps<RoundedProps>) =>
    rounded &&
    css`
        border-radius: 3px;
    `;
